export default {
      id: "video-event_talking-on-cell-phone-usage",
      viewBox: "0 0 15 21",
      url: __webpack_public_path__ + "img/icons.svg#video-event_talking-on-cell-phone",
      toString: function () {
        return this.url;
      }
    }